import {Component, HostListener, OnInit, ViewChild} from '@angular/core';
import {NgForm} from '@angular/forms';
import {ApiClientService} from '../../../services/api-client.service';
import {SettingsIncidentReport} from '../../../types/data.types';
import {UrlService} from '../../../services/url.service';
import {ConstantsService} from '../../../services/constants.service';
import {SettingsIncidentReportService} from '../../../services/settings-incident-report.service';

declare const toastr: any;
declare const $: any;
declare const swal: any;

@Component({
    selector: 'settings-incident-report-modal',
    templateUrl: './settings-incident-report-modal.component.html',
    styleUrls: ['./settings-incident-report-modal.component.scss']
})
export class SettingsIncidentReportModalComponent implements OnInit {
    @ViewChild('form') form;
    showModal = false;
    disabledSubmit = false;
    data: SettingsIncidentReport = new SettingsIncidentReport();
    multiselectSettings = {
        singleSelection: false,
        text: 'Select Buildings',
        selectAllText: 'Select All',
        unSelectAllText: 'Deselect All',
        scrollable: true,
        enableSearchFilter: true,
        classes: 'with-filter'
    };

    constructor(
        public api: ApiClientService,
        public settingsIncidentReportService: SettingsIncidentReportService,
        public urlService: UrlService
    ) {}

    ngOnInit() {
        setTimeout( () => this.showModal = true, 300);
        this.urlService.modalOpened.emit();
    }

    hideModal() {
        if (this.form.dirty && this.form.touched) {
            swal(ConstantsService.getSwalConfig('Close without saving?', 'Do you want to delete unsaved data?'),
                () => {
                    this.settingsIncidentReportService.showCreateModal = false;
                    this.urlService.modalClosed.emit();
                }
            );
        } else {
            this.settingsIncidentReportService.showCreateModal = false;
            this.urlService.modalClosed.emit();
        }
    }

    onSubmit(form: NgForm) {
        if (!form.valid) {
            if (!form.value.name) toastr.warning('Name must be entered.');
            if (!form.value.buildings) toastr.warning('Buildings should not be blank.');
            return;
        }

        const data: any = {
            name: this.data.name,
            buildings: this.data.buildings.map(b => ({
                bdId: b.id,
                name: b.itemName
            }))
        };

        this.disabledSubmit = true;

        this.api.post('domainIncidentReports', '/v1/settings.json', data).subscribe(
            () => this.updateView('Incident Report Settings created successfully'),
            error => {
                this.disabledSubmit = false;
                this.api.errorHandler(error, 'Failed to create Incident Report Settings');
            }
        );
    }

    updateView(msg: string): void {
        toastr.success(msg);
        this.settingsIncidentReportService.getData();
        this.form.reset();
        this.hideModal();
    }

    @HostListener('document:keydown.escape', ['$event']) onKeydownHandler(event: KeyboardEvent) {
        setTimeout(() => this.hideModal(), 100);
    }
}



// WEBPACK FOOTER //
// /app/src/app/views/settings-incident-report/settings-incident-report-modal/settings-incident-report-modal.component.ts